import React, { useEffect, useState } from 'react'
import { connectStore } from 'redux-box'
import { module as onboard } from "@st/onboard";
import { module as inviteCode } from "@st/inviteCode";

const MonthlyReportingView = (props) => {

  const [loading,setLoading] = useState(true)
  const [schoolCode,setSchoolcode] = useState(null)

  const handleIframeLoad = ()=>{
      setLoading(false)
  }

  useEffect(() => {
    // setLoading(true);
    console.log(props);
    let school = props.inviteCode.adminSchoolList.find(
      (school) => school.id === props.onboard.user.school
    );
    if (school) {
      setSchoolcode(school.school_code);
    }
    // setLoading(false);
  }, [props.onboard.user, props.inviteCode.adminSchoolList]);

  return (
    <div style={{ width: "100%", height: "100%", marginLeft: "1rem" }}>
      {loading && (
        <div
          style={{
            width: "100%",
            height: "85vh",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
          }}
        >
          <img
            alt="loading"
            width="60"
            height="60"
            src={require("static/img/Theme-loader.gif")}
          />
        </div>
      )}
      {schoolCode && (
        <iframe
          src={`https://lookerstudio.google.com/embed/u/2/reporting/d256a474-789c-466f-ae65-3f5cc0494a36/page/p_w886m40p8c/edit?params=%7B%22df183%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580${schoolCode}%22%7D`}
          frameborder="0"
          style={{ border: 0, width: "100%", height: "85vh" }}
          allowfullscreen
          onLoad={handleIframeLoad}
          title="Monthly Reporting View"
          sandbox="allow-storage-access-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      )}
    </div>
  );
}

export default connectStore({
  onboard,
  inviteCode,
})(MonthlyReportingView);